import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "User",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "File Name",
    dataIndex: "file",
    render: defaultRender,
  },
  {
    title: "File No.",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "Submit",
    dataIndex: "submit",
    render: defaultRender,
  },
  {
    title: "Assigned To",
    dataIndex: "assignTo",
    render: defaultRender,
    width: 200,
    onFilter: (value, record) => {
      return record?.employee_id === value;
    },
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value)=>(<StatusBadge status={value}/>),
  },
  {
    title: "Action",
    dataIndex: "action",
    fixed: "right",
  },
];

export default columns;
